import * as yup from 'common/yup';
import {enumType} from 'common/enumType';
import {SearchFieldType} from 'types/SearchFieldType';

export const SearchMethod = enumType({
   field: 'field',
   unused: 'unused',
   noProcessedFiles: 'noProcessedFiles',
   noHistory: 'noHistory',
   none: 'none',
});

export const SearchCriteriaSchema = yup.object({
   method: yup.string().oneOf(SearchMethod.keys).default(SearchMethod.enum.none),
   searchField: yup.string().oneOf(SearchFieldType.keys).default(SearchFieldType.enum.NAME),
   containingText: yup.string(),
   daysUnused: yup.number().moreThan(0).default(1),
});

export type ISearchCriteria = yup.InferType<typeof SearchCriteriaSchema>;
